import { render, staticRenderFns } from "./IconFlash.vue?vue&type=template&id=2edd2838"
import script from "./IconFlash.vue?vue&type=script&lang=js"
export * from "./IconFlash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports